// USA
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    TITLE: "Menu",
    DASHBOARD: {
      TITLE: "Dashboard"
    },
    PROFILE: {
      TITLE: "profile"
    },
    LOGOUT: {
      TITLE: "Sign out"
    },
    COMPANY_MANAGEMENT: {
      TITLE: "Company management",
      COMPANY: "Company"
    },
    CAMPAIGN_MANAGEMENT: {
      TITLE: "Campaign management",
      CAMPAIGN: "Campaign"
    }
  },
  AUTH: {
    TITLE: "Kepttam",
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "Login Account",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    UPDATE_PASSWORD: {
      TITLE: "New password",
      DESC: "The code used to change the password has been sent to your email address.",
      TIME_ALEAT: "Please change password within {second} seconds.",
      TIMEOUT: "Code expired"
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered.",
      NEW_USER: "New Here?",
      CREATE_ACCOUNT: "Create an Account",
      CONFIRM_REGISTER: "You have successfully subscribed. Please check your email to confirm your subscription."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username",
      CODE: "Code",
      NEW_PASSWORD: "New password",
      CONFIRM_NEW_PASSWORD: "Confirm new password",
      COMPANY_NAME: "Company name",
      SUBMIT: "Submit",
      CANCEL: "Cancel"
    },
    VALIDATION: {
      INVALID: "Field is not valid",
      REQUIRED: "Field is required",
      MIN_LENGTH: "Field minimum length is {min}",
      MAX_LENGTH: "Field maximum length is {max}",
      MIN_MAX_LENGTH: "Field minimum length is {min} and maximum length is {max}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid",
      CUSTOM_REQUIRED: "{field} is required"
    }
  },
  PAGE: {
    DEFAULT: {
      TABLE: {
        SEARCH: "Search",
        CLEAR: "clear",
        NEW: "New",
        DATA_NOT_FOUND: "Data not found",
        FIELDS: {
          INDEX: "Index",
          NAME: "Name",
          SWITCH: "Enable",
          QUANTITY: "Quantity",
          POINT: "Point",
          STATUS: {
            TITLE: "Status",
            ACTIVE: "Active",
            INACTIVE: "Inactive",
            WAITING_APPROVE: "Waiting approve",
            APPROVED: "Approved",
            UNAPPROVED: "Unapproved"
          },
          ACTION: {
            TITLE: "Action",
            EDIT: "Edit",
            DELETE: {
              TITLE: "Delete",
              DESC: "Confirm data deletion"
            }
          }
        },
        PER_PAGE: "Per page"
      },
      FORM: {
        TITLE: "Form",
        FIELDS: {
          NAME: "Name",
          DETAIL: "Detail",
          START_DATE: "Start date",
          END_DATE: "End date",
          IMAGE: "Image",
          MAIN_IMAGE: "Main image",
          OTHER_IMAGE: "Other image",
          QUANTITY: "Quantity",
          POINT: "Point"
        },
        PLACEHOLDER: {
          CHOOSE_DATE: "Choose date",
          CHOOSE_IMAGE: "Choose an image."
        },
        OPTIONS: {
          ALL: "All",
          CUSTOM: "Custom"
        },
        BTN_SUBMIT: "Submit",
        BTN_OK: "Ok",
        BTN_CANCEL: "Cancel",
        BTN_ADD: "ADD",
        VALIDATION: {
          INVALID: "Field is not valid",
          REQUIRED: "Field is required",
          MIN_LENGTH: "Field minimum length is {min}",
          MAX_LENGTH: "Field maximum length is {max}",
          MIN_MAX_LENGTH: "Field minimum length is {min} and maximum length is {max}",
          CHECK_DATA_ALL_TAB: "Some field is not valid. Please check data in all tab.",
          DUPLICATE: "Data is exit"
        },
        PS_NOTE: {
          MIN_RECORD: "Field minimum record is 1"
        }
      }
    },
    DASHBOARD: {},
    PROFILE: {
      TABLE: {
        FIELDS: {
          FULLNAME: "Fullname",
          EMAIL: "Email"
        }
      },
      FORM: {
        TABS: {
          DATA: "Data",
          PASSWORD: "Password"
        },
        FIELDS: {
          FULLNAME: "Fullname",
          EMAIL: "Email",
          OLD_PASSWORD: "Old password",
          NEW_PASSWORD: "new password",
          CONFIRM_NEW_PASSWORD: "Confirm new password"
        }
      }
    },
    COMPANY: {
      FORM: {
        FIELDS: {
          LOGO_IMAGE: "Logo image"
        }
      }
    },
    CAMPAIGN: {
      TABLE: {
        BUTTON: {
          NEW_CAMPAIGN_RECEIPT: "New campaign receipt"
        },
        FIELDS: {
          CAMPAIGN_URL: "CAMPAIGN URL",
          START_DATE: "Start date",
          END_DATE: "End date",
          CREATED_AT: "Date",
          CUSTOMER: "Customer",
          RECEIPT_TYPE: "Receipt type",
          POINT: "Point",
          VERIFY_CODE: "Verify code",
          REMARK: "Remark"
        }
      },
      FORM: {
        HINT: {
          IS_ACTIVE: "Please update your LINE LIFF ID to activate the event."
        },
        MODAL: {
          PRODUCT_TITLE: "Product form",
          REWARD_TITLE: "Reward form",
          CUSTOMER_RECEIPT: "Customer receipt"
        },
        ACTIVE_WARNING: 'When "LINE LIFF ID" is update.<br> This Campaign will be active when date is equal start and then you cannot edit campaign data.',
        CONFRIM_ENABLE: "Do you want to <span style='color:green'>enable</span> activity to use it?",
        CONFRIM_DISABLE: "Do you want to <span style='color:red'>disable</span> the activity?",
        CAMPAIGN_RECEIPT: {
          TITLE: "Campaign receipt form",
          TAB: {
            GENERAL: "General",
            RECEIPT: "Receipt type",
            PRODUCT: "Product",
            REWARD: "Reward",
            CUSTOMER: "Customer"
          },
          FIELDS: {
            TERM_AND_CONDITION: "Term and condition (PDPA)",
            CUSTOMER: "Customer",
            RECEIPT_TYPE: "Receipt type",
            REWARD: "Reward",
            IS_APPROVE: "Approval",
            REASON_NOT_APPROVE: "REASON NOT APPROVE",
            UNAPPROVED_REASON_REMARK: "REASON REMARK",
            POINT: "Point",
            VERIFY_CODE: "Verify code",
            DATE: "Date",
              QUESTION: "QUESTION",
              ANSWER: "answer",
            REMARK: "Remark",
            TOTAL_SCORE: "Total score",
            CODE: "Code",
            ANSWER_DETAIL: "Answer detail",
            DATE_QUESTION: "Date question",
                 OCR: "OCR",
          }
        }
      }
    }
  },
  RESPONSE_MESSAGE: {
    ERROR_OCCURRED: "System error occurred",
    USER_NOT_FOUND: "User not found",
    EMAIL_DUPLICATE: "This email has already been used.",
    CODE_EXPIRED: "Code expired",
    SAVE_DATA_SUCCESS: "Success to save data",
    SAVE_DATA_SUCCESS_LINE_TOKEN_AUTH_FAILE: "<p style='color:red;'>The work message will not be notified due to an invalid Line Message Token. Please check again.</p>",
    SAVE_DATA_FAILURE: "Failed to save data",
    DELETE_DATA_SUCCESS: "Success to delete data",
    DELETE_DATA_FAILURE: "Failed to delete data",
    DATA_INVALID: "Incorrect information",
    DATA_NOT_FOUND: "Data not found",
    DATA_DUPLICATE: "Data dupicate",
    COMPANY_NAME_DUPLICATE: "This company name has already been used.",
    VERIFY_CODE_DUPLICATE: "This verify code has already been used."
  },
  LOADING: "loading"
};